import { webApiBuildUrl } from '@api/utils'

/**
 * api stocks url
 */
export function allStocksUrl() {
    return webApiBuildUrl('api/company/stocks')
}
